import type { CanvasEditor, CanvasEditorSnapshot } from "../controller/types";

const COLORS = ["#ffffff", "#fff2a8", "#dbeafe", "#dcfce7", "#fce7f3"] as const;

export function CanvasSelectionToolbar({
  editor,
  snapshot,
  onDuplicate,
  onShowProperties,
  onEditDiagram,
}: {
  readonly editor: CanvasEditor;
  readonly snapshot: CanvasEditorSnapshot;
  readonly onDuplicate: () => void;
  readonly onShowProperties: () => void;
  readonly onEditDiagram?: () => void;
}) {
  const ids = [...snapshot.selection.nodeIds];
  if (snapshot.readOnly || ids.length === 0) return null;
  const nodes = snapshot.canvas.nodes.filter((node) => snapshot.selection.nodeIds.has(node.id));
  const editableIds = nodes.filter((node) => node.props.locked !== true).map((node) => node.id);
  const allLocked = nodes.every((node) => node.props.locked === true);
  const batchProps = (targetIds: readonly string[], props: Record<string, string | boolean>) => editor.dispatch({
    type: "batch",
    commands: targetIds.map((id) => ({ type: "update-node" as const, id, patch: { props } })),
  });
  return (
    <div
      className="canvas-selection-toolbar"
      role="toolbar"
      aria-label="所选节点快捷操作"
      style={{ position: "absolute", zIndex: 24, left: "50%", bottom: 14, display: "flex", gap: 4, alignItems: "center", maxWidth: "calc(100% - 24px)", overflowX: "auto", padding: 6, border: "1px solid #cbd5e1", borderRadius: 12, background: "rgba(255,255,255,.97)", boxShadow: "0 10px 30px rgba(15,23,42,.16)", transform: "translateX(-50%)" }}
    >
      <span style={{ padding: "0 6px", color: "#64748b", fontSize: 12, whiteSpace: "nowrap" }}>已选择 {ids.length} 项</span>
      {onEditDiagram && <button type="button" onClick={onEditDiagram} style={{ whiteSpace: "nowrap" }}>编辑工程图</button>}
      <button type="button" aria-label="创建副本" title="创建副本 (Ctrl+D)" onClick={onDuplicate}>⧉</button>
      <button type="button" aria-label="打开属性检查器" title="属性检查器" onClick={onShowProperties}>⚙</button>
      <button type="button" aria-label={allLocked ? "解锁所选节点" : "锁定所选节点"} onClick={() => batchProps(ids, { locked: !allLocked })}>{allLocked ? "🔓" : "🔒"}</button>
      <button type="button" aria-label="置于顶层" disabled={editableIds.length === 0} onClick={() => editor.dispatch({ type: "reorder-nodes", nodeIds: editableIds, operation: "bring-front" })}>↑</button>
      {COLORS.map((color) => <button key={color} type="button" aria-label={`填充颜色 ${color}`} disabled={editableIds.length === 0} onClick={() => batchProps(editableIds, { fill: color })} style={{ width: 28, height: 28, border: "1px solid #cbd5e1", borderRadius: 999, background: color }} />)}
      <button type="button" aria-label="删除所选节点" disabled={editableIds.length === 0} onClick={() => editor.dispatch({ type: "delete-nodes", ids: editableIds })} style={{ color: "#b91c1c" }}>⌫</button>
    </div>
  );
}
